// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

// 导入ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

// 引入axios
import axios from 'axios';
// axios.defaults.baseURL = 'http://127.0.0.1:8080';
axios.defaults.baseURL = 'https://kgapi.e-ai-edu.com';
Vue.prototype.$http = axios;

Vue.config.productionTip = false

// 引入外部css文件
import '@/style/global.css'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js